// extracted by mini-css-extract-plugin
export default {"sections":"AccessTPPs_sections__Hl8ux api-enabler-styles_overviewSections__SHdCd zb-container","section":"AccessTPPs_section__JhQO4 api-enabler-styles_overviewSection__Dxvs2"};